import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Download } from "lucide-react";

const PrintableFriday = () => {
  const [item, setItem] = useState<any>(null);

  useEffect(() => {
    supabase
      .from("printable_friday")
      .select("*")
      .eq("is_active", true)
      .order("week_start", { ascending: false })
      .limit(1)
      .maybeSingle()
      .then(({ data }) => setItem(data));
  }, []);

  if (!item) return null;

  return (
    <section className="container mx-auto px-4 py-3">
      <div className="bg-gradient-to-br from-amber-100 to-orange-100 border-2 border-amber-200 rounded-3xl p-4 md:p-5 shadow flex items-center gap-4">
        <div className="text-4xl">🖨️</div>
        <div className="flex-1">
          <div className="text-amber-700 text-xs font-bold uppercase">Printable Friday</div>
          <h3 className="text-lg font-extrabold text-gray-900">{item.title}</h3>
          {item.description && (
            <p className="text-sm text-gray-700">{item.description}</p>
          )}
        </div>
        <a
          href={item.download_url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 bg-amber-400 hover:bg-amber-500 text-white font-bold px-4 py-2 rounded-full shadow"
        >
          <Download className="w-4 h-4" /> Download
        </a>
      </div>
    </section>
  );
};

export default PrintableFriday;
